import { useCallback, useEffect } from 'react'
import { usePrevious, useSessionStorage } from 'react-use'

import { STORAGE_KEYS } from '@/shared/constants'

/**
 * Pagination hook for list components
 */
export const useCompPagination = ({ compId, defaultPerPage }: { compId: string; defaultPerPage: number }) => {
  // const [pagination, setPagination] = useState(getInitialPagination(window.appID, compId, defaultPerPage))
  const [pagination, setPagination] = useSessionStorage(`${STORAGE_KEYS.COMP_PAGINATION}:${window.appID}-${compId}`, {
    page: 0,
    perPage: defaultPerPage,
  })

  const prevPerPage = usePrevious(defaultPerPage)

  const update = useCallback((page: number, perPage: number) => {
    setPagination({ page, perPage })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // sync perPage if defaultPerPage changes
  useEffect(() => {
    if (prevPerPage !== defaultPerPage) {
      update(0, defaultPerPage)
    }
  }, [defaultPerPage, prevPerPage, update])

  return {
    pagination,
    setPagination: update,
  }
}
